// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import React, { Children, FC } from "react";

interface OwnProps {
    TypographyStyle?: TypographyPresentationProps;
}

type Props = OwnProps;
const NonTranslationTypography: FC<Props> = ({ children, TypographyStyle }) => {
    return (
        <Typography {...(TRANSLATE_OBJECT as any)} {...TypographyStyle}>
            {children}
        </Typography>
    );
};

export default NonTranslationTypography;
